import { PERMISSION_LEVEL } from "@constants/permissionLevel"

import useHasAccess from "./useHasAccess"
import useUser from "./useUser"

export default function useCanChangeAttachment() {
    const { user } = useUser()
    const { hasPermission } = useHasAccess()

    const editPermissions: Partial<Record<ObjectType, keyof UserPermissionsOnly>> = {
        job: "jobs_edit_permission",
        estimate: "estimates_edit_permission",
        invoice: "invoices_edit_permission",
        credit_note: "invoices_edit_permission", // Credit notes take the invoices permission, as on the backend
        purchase_order: "purchase_orders_edit_permission",
        bill: "bills_edit_permission",
        vendor_credit: "bills_edit_permission", // Vendor credits take the bills permission, as on the backend
    }

    return (attachment: Attachment, parentObjectType: ObjectType) => {
        const editPermission = editPermissions[parentObjectType]

        // Below full edit permission, a user can change only the attachments they uploaded
        return (
            !!editPermission &&
            (hasPermission(editPermission, PERMISSION_LEVEL.FULL) ||
                (hasPermission(editPermission, PERMISSION_LEVEL.RESTRICTED) &&
                    attachment.uploaded_by?.id === user?.id))
        )
    }
}
